import { makeSubject as t, share as e, filter as r, map as n, merge as o, mergeMap as a, empty as u, fromValue as c, takeUntil as i, fromPromise as h, toPromise as s, take as d, onStart as l } from "wonka";

import { makeOperation as m, createRequest as f } from "@urql/core";

const addAuthAttemptToOperation = (t, e) => m(t.kind, t, {
  ...t.context,
  authAttempt: e
});

function authExchange({addAuthToOperation: m, getAuth: p, didAuthError: k, willAuthError: w}) {
  return ({client: x, forward: y}) => {
    const A = new Map;
    const {source: E, next: S} = t();
    let g = null;
    return t => {
      function mutate(t, e, n) {
        const o = x.createRequestOperation("mutation", f(t, e), n);
        return s(d(1)(r((t => t.operation.key === o.key))(l((() => S(o)))(R))));
      }
      const updateAuthState = t => {
        g = t;
        q = void 0;
        A.forEach(S);
        A.clear();
      };
      let q = Promise.resolve().then((() => p({
        authState: g,
        mutate
      }))).then(updateAuthState);
      const refreshAuth = t => {
        t = addAuthAttemptToOperation(t, !0);
        A.set(t.key, t);
        if (!q) {
          q = p({
            authState: g,
            mutate
          }).then(updateAuthState).catch((() => updateAuthState(null)));
        }
      };
      const v = e(t);
      const O = r((t => "teardown" === t.kind))(v);
      const M = r((t => "teardown" !== t.kind))(v);
      const P = n((t => m({
        operation: t,
        authState: g
      })))(o([ E, a((t => {
        if (A.has(t.key)) {
          return u;
        }
        if (!q && w && w({
          operation: t,
          authState: g
        })) {
          refreshAuth(t);
          return u;
        } else if (!q) {
          return c(addAuthAttemptToOperation(t, !1));
        }
        const e = r((e => "teardown" === e.kind && e.key === t.key))(v);
        return i(e)(n((() => addAuthAttemptToOperation(t, !1)))(h(q)));
      }))(M) ]));
      const R = e(y(o([ P, O ])));
      return r((({error: t, operation: e}) => {
        if (t && k && k({
          error: t,
          authState: g
        })) {
          if (!e.context.authAttempt) {
            refreshAuth(e);
            return !1;
          }
        }
        return !0;
      }))(R);
    };
  };
}

export { authExchange };
//# sourceMappingURL=urql-exchange-auth.mjs.map
